export default {
	FILL_FAVORITE_HEART: 'FILL_FAVORITE_HEART',
	EMPTY_FAVORITE_HEART: 'EMPTY_FAVORITE_HEART',
	SET_WEDDING_ID: 'SET_WEDDING_ID',
	SET_SAVED_VENDOR_ID: 'SET_SAVED_VENDOR_ID',
};
